import {IPFS} from "ipfs-core"
import Identities from "orbit-db-identity-provider"
import React, {useCallback, useEffect, useState} from "react"
import {BrowserRouter as Router} from "react-router-dom"
import {AppContainer} from "./components/App/AppContainer"
import {SignedInHome} from "./components/App/SignedInHome"
import {LandingContainer} from "./components/Landing/LandingContainer"
import {AuthContext} from "./context/Auth.context"
import {BackendContext} from "./context/BackendContext"
import {useAuth} from "./hooks/useAuth"
import {useInitBackend} from "./hooks/useInitBackend"
import {useMetadata} from "./hooks/useMetadata"
import "@fontsource/plus-jakarta-sans";

const App = () => {
  const {keys, authMethod} = useAuth()
  const {ipfs, orbit, fs} = useInitBackend(keys)
  const {metadata, setIsGitSupported} = useMetadata()
  const [isInit, setIsInit] = useState(false)

  useEffect(() => {
    if (ipfs === undefined || keys === undefined) {
      return
    }
    setIsInit(true)
  }, [keys, ipfs])

  return (
    <Router>
      <AuthContext.Provider value={{authMethod, keys}}>
        <BackendContext.Provider value={{ipfs, orbit, fs, metadata, setIsGitSupported}}>
          <AppContainer isInit={isInit}>
            {
              keys === null
                ? <LandingContainer/>
                : <SignedInHome/>
            }
          </AppContainer>
        </BackendContext.Provider>
      </AuthContext.Provider>
    </Router>
  )
}

export default App
